type LogCustomEvent = (event: { name: string; body: object }) => void
// typed as `any` because `rum.recordError`s argument is typed as `any`
// this will get called with the result of `useRouteError()` in `useErrorBoundary` which is typed as `unknown`
type LogCustomError = (error: any) => void
const loadRum = async (): Promise<null | {
  logCustomEvent: LogCustomEvent
  logCustomError: LogCustomError
}> => {
  return null
  // if (
  //   window.location.hostname.includes("dev-ft.myveevatrials.com") &&
  //   !window.location.hostname.startsWith("myvc-") &&
  //   process.env.NODE_ENV !== "test"
  // ) {
  //   const REACT_APP_SHA = process.env.REACT_APP_SHA
  //   const REACT_APP_VERSION = process.env.REACT_APP_VERSION
  //   const REACT_APP_cloudwatch_monitor_id =
  //     process.env.REACT_APP_cloudwatch_monitor_id
  //   if (
  //     !REACT_APP_SHA ||
  //     !REACT_APP_VERSION ||
  //     !REACT_APP_cloudwatch_monitor_id
  //   ) {
  //     // oxlint-disable-next-line
  //     console.error(
  //       "🚨 failed to configure cloudwatch - missing environment variables"
  //     )
  //     return null
  //   }
  //   return import("aws-rum-web").then(({ AwsRum }) => {
  //     try {
  //       // https://us-east-1.console.aws.amazon.com/cloudwatch/home?region=us-east-1#rum:dashboard?tab=list
  //       // TODO MYVC-43349 Configure this for dev vs prod as needed
  //       const APPLICATION_ID = REACT_APP_cloudwatch_monitor_id
  //       // This is the value set in patients + sites + sponsors package.json's
  //       const APPLICATION_VERSION = REACT_APP_VERSION
  //       const APPLICATION_REGION = "us-east-1"
  //
  //       const awsRum = new AwsRum(
  //         APPLICATION_ID,
  //         APPLICATION_VERSION,
  //         APPLICATION_REGION,
  //         {
  //           releaseId: REACT_APP_VERSION,
  //           // Don't allow rum to limit the amount of events in the session
  //           sessionEventLimit: 0,
  //           sessionAttributes: {
  //             sha: REACT_APP_SHA,
  //           },
  //           sessionSampleRate: 1,
  //           endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
  //           telemetries: ["performance", "errors", "http"],
  //           allowCookies: true,
  //           enableXRay: false,
  //           signing: false,
  //         }
  //       )
  //       return {
  //         logCustomEvent: (event) => {
  //           awsRum.recordEvent(event.name, event.body)
  //           // Force rum to log this event and anything in its queue
  //           awsRum.dispatchBeacon()
  //           awsRum.dispatch()
  //         },
  //         logCustomError: (error) => {
  //           // Force rum to log this error and anything in its queue
  //           awsRum.recordError(error)
  //           awsRum.dispatchBeacon()
  //           awsRum.dispatch()
  //         },
  //       }
  //     } catch (error) {
  //       // oxlint-disable-next-line
  //       console.error(error)
  //     }
  //     return null
  //   })
  // }
  // return null
}

const rum = loadRum()

export const getRum = () => {
  return rum
}
